import {apiRequest} from "../../../utils/AxiosHelper";
import APIs from "../../../modules/settings/APIs";
import {useAppSelector} from "../../../hooks/hooks";
import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {User} from "../../../types";

interface UserParams {
  propertyFind?: string;
  valueFind?: string;
  propertyOrder?: string;
}

const fetchUsers = async (params: UserParams): Promise<User[]> => {
  const response = await apiRequest.get(APIs.parameters.common.user.list, {
    params: {
      propertyFind: params.propertyFind || 'u.fullName',
      valueFind: params.valueFind || '',
      propertyOrder: params.propertyOrder || 'u.fullName'
    }
  });

  console.log('User API Response:', response.data); // Debug log

  return response.data.data;
};

export const useUser = (params: UserParams = {}, queryOptions?: Partial<UseQueryOptions<User[], Error>>) => {
  const {isAuthenticated, token} = useAppSelector((state) => state.session);

  return useQuery({
    queryKey: ['users', params.valueFind], // Use only the search value as key
    queryFn: () => fetchUsers(params),
    enabled: isAuthenticated && !!token,
    ...queryOptions,
  });
};
